<template>
  <nav v-show="isNavBarVisible" id="navbar-main" class="navbar is-fixed-top">
    <div class="navbar-brand">
      <div class="navbar-item" style="padding: 0 1em">
        <router-link :to="{ name: 'Home' }">
          <!-- <img
            :src="config.logoUrl"
            :alt="config.appName"
            style="max-height: 4em"
          /> -->
          {{ displayAppName }}
        </router-link>
      </div>
      <div class="navbar-item">
        <div class="control">
          <b-autocomplete
            :data="searchResults"
            placeholder="Search ..."
            icon="magnify"
            field="title"
            :style="{
              width: searchFocussed ? '300px' : 'auto'
            }"
            :loading="isSearching"
            class="searchbox"
            @typing="getSearch"
            @select="option => (selected = option)"
            @focus="searchFocussed = true"
            @blur="searchFocussed = false"
          >
            <template slot-scope="props">
              <div
                v-if="
                  props.option.type === 'series' ||
                    props.option.type === 'movie'
                "
              >
                <div class="columns">
                  <!-- <div class="column is-2">
                    <figure
                      v-if="
                        props.option.mediadata &&
                          props.option.mediadata.titleImage
                      "
                    >
                      <img :src="props.option.mediadata.titleImage" />
                    </figure>
                  </div> -->
                  <div class="column is-12">
                    <b-tag
                      type="is-primary"
                      class="is-uppercase has-text-weight-bold"
                      >{{ props.option.type }}</b-tag
                    >
                    <router-link
                      :to="{
                        name: 'MediaDetail',
                        params: { id: props.option.id }
                      }"
                      class="has-margin-left-5"
                    >
                      <strong>{{ props.option.value }}</strong>
                    </router-link>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="columns">
                  <!-- <div class="column is-2"></div> -->
                  <div class="column is-12">
                    <b-tag
                      type="is-primary"
                      class="is-uppercase has-text-weight-bold"
                      >{{ props.option.type }}</b-tag
                    >
                    <router-link
                      :to="{
                        name: 'Metadata',
                        params: {
                          type: props.option.type,
                          id: props.option.id
                        }
                      }"
                      class="has-margin-left-5"
                    >
                      <strong>{{ props.option.value }}</strong>
                    </router-link>
                  </div>
                </div>
              </div>
            </template>
          </b-autocomplete>
          <!-- <input
            v-if="isAuthenticated"
            class="input"
            v-model="query"
            @keydown.enter="search"
            placeholder="Search everywhere..."
          /> -->
        </div>
      </div>
    </div>
    <div class="navbar-brand is-right">
      <a
        class="navbar-item navbar-item-menu-toggle is-hidden-desktop"
        @click.prevent="menuNavBarToggle"
      >
        <b-icon :icon="menuNavBarToggleIcon" custom-size="default" />
      </a>
    </div>
    <div
      class="navbar-menu fadeIn animated faster"
      :class="{ 'is-active': isMenuNavBarActive }"
    >
      <div class="navbar-end">
        <!-- <router-link :to="{ name: 'HowItWorks' }" class="navbar-item">
          <span>How it Works</span>
        </router-link>
        <NavBarMenu>
          <div>
            <span>Pay Rights</span>
          </div>

          <div slot="dropdown" class="navbar-dropdown">
            <router-link
              :to="{
                name: 'Metadata',
                params: { type: 'right', id: payRightsId },
              }"
              class="navbar-item"
              >All</router-link
            >
            <router-link
              v-for="item in genreMenu"
              :key="item.id"
              :to="{
                name: 'MetadataMulti',
                params: { id1: payRightsId, id2: item.id },
              }"
              class="navbar-item"
              >{{ item.value }}</router-link
            >
          </div>
        </NavBarMenu>
        <NavBarMenu>
          <div>
            <span>Free Rights</span>
          </div>

          <div slot="dropdown" class="navbar-dropdown">
            <router-link
              :to="{
                name: 'Metadata',
                params: { type: 'right', id: freeRightsId },
              }"
              class="navbar-item"
              >All</router-link
            >
            <router-link
              v-for="item in genreMenu"
              :key="item.id"
              :to="{
                name: 'MetadataMulti',
                params: { id1: freeRightsId, id2: item.id },
              }"
              class="navbar-item"
              >{{ item.value }}</router-link
            >
          </div>
        </NavBarMenu>
        <NavBarMenu class="has-divider">
          <div>
            <span>Content</span>
          </div>

          <div slot="dropdown" class="navbar-dropdown">
            <router-link
              v-for="item in genreMenu"
              :key="item.id"
              :to="{
                name: 'Metadata',
                params: { type: item.metadata_type, id: item.id },
              }"
              class="navbar-item"
              >{{ item.value }}</router-link
            >
            <router-link
              :to="{
                name: 'Metadata',
                params: { type: 'tag', id: 1005 },
              }"
              class="navbar-item"
              >From Africa</router-link
            >
            <router-link
              :to="{
                name: 'Metadata',
                params: { type: 'tag', id: 1006 },
              }"
              class="navbar-item"
              >For Africa</router-link
            >
            <router-link
              :to="{
                name: 'Packages',
              }"
              class="navbar-item has-text-weight-bold"
              >Packages</router-link
            >
          </div>
        </NavBarMenu> -->
        <router-link
          v-if="isAuthenticated"
          :to="{ name: 'ManageAllMedia' }"
          class="navbar-item"
        >
          <b-icon icon="folder-multiple-image" custom-size="default"></b-icon>
          <span>Media</span>
        </router-link>
        <router-link
          v-if="isAuthenticated"
          :to="{ name: 'ManageChannels' }"
          class="navbar-item"
        >
          <b-icon icon="television" custom-size="default"></b-icon>
          <span>Channels</span>
        </router-link>
        <router-link
          v-if="!isAuthenticated"
          :to="{ name: 'Login' }"
          class="navbar-item"
        >
          <b-icon icon="login" custom-size="default"></b-icon>
          <span>Log in</span>
        </router-link>
        <!-- Create Account removed - users are created by tenant admin -->

        <!-- <NavBarMenu v-if="isAuthenticated && isBuyer" class="has-divider">
          <div class="is-user-name">
            <b-icon icon="basket-outline" custom-size="default" />
          </div>
          <div slot="dropdown" class="navbar-dropdown">
            <router-link :to="{ name: 'CartByList' }" class="navbar-item">
              <b-icon icon="basket-outline" custom-size="default"></b-icon>
              <span>My Collections</span>
            </router-link>
            <router-link :to="{ name: 'Home' }" class="navbar-item">
              <b-icon
                icon="book-open-page-variant"
                custom-size="default"
              ></b-icon>
              <span>Catalogue</span>
            </router-link>
            <router-link
              v-if="isBuyer"
              :to="{ name: 'ContentRequirements' }"
              class="navbar-item"
            >
              <b-icon icon="settings" custom-size="default"></b-icon>
              <span>Content Requirements</span>
            </router-link>
            <router-link
              v-if="isBuyer"
              :to="{ name: 'TitleSupplierRequest' }"
              class="navbar-item"
            >
              <b-icon icon="bullhorn-outline" custom-size="default"></b-icon>
              <span>Request Title/Supplier</span>
            </router-link>
          </div>
        </NavBarMenu> -->
        <NavBarMenu v-if="isAuthenticated && (isAdmin || isScheduler || isTraffic)" class="has-divider">
          <div class="is-user-name">
            <span>{{ isAdmin ? 'Admin' : (isScheduler ? 'Scheduler' : 'Traffic') }}</span>
          </div>

          <div slot="dropdown" class="navbar-dropdown">
            <!-- All Media - only for Traffic and Scheduler (Admin uses main Media menu) -->
            <router-link
              v-if="isTraffic || isScheduler"
              :to="{ name: 'ManageAllMedia' }"
              class="navbar-item"
            >
              <b-icon
                icon="folder-multiple-image"
                custom-size="default"
              ></b-icon>
              <span>All Media</span>
            </router-link>
            <!-- Channels - only for Traffic and Scheduler (they also have main Channels menu) -->
            <router-link
              v-if="isTraffic || isScheduler"
              :to="{ name: 'ManageChannels' }"
              class="navbar-item"
            >
              <b-icon
                icon="television"
                custom-size="default"
              ></b-icon>
              <span>Channels</span>
            </router-link>
            <router-link
              v-if="isAdmin || isSuperAdmin"
              :to="{ name: 'ManageMetadata' }"
              class="navbar-item"
            >
              <b-icon icon="pencil-box-multiple" custom-size="default"></b-icon>
              <span>Metadata</span>
            </router-link>
            <!-- Channels Config - for Admin to configure channels -->
            <router-link
              v-if="isAdmin || isSuperAdmin"
              :to="{ name: 'ManageChannels' }"
              class="navbar-item"
            >
              <b-icon
                icon="television"
                custom-size="default"
              ></b-icon>
              <span>Channel Config</span>
            </router-link>
            <router-link
              v-if="isAdmin || isSuperAdmin"
              :to="{ name: 'ManageUsers' }"
              class="navbar-item"
            >
              <b-icon
                icon="account-multiple-outline"
                custom-size="default"
              ></b-icon>
              <span>Users</span>
            </router-link>
            <router-link
              v-if="isAdmin || isSuperAdmin"
              :to="{ name: 'ManageStorage' }"
              class="navbar-item"
            >
              <b-icon icon="cloud-outline" custom-size="default"></b-icon>
              <span>Storage</span>
            </router-link>
            <router-link
              v-if="isAdmin"
              :to="{ name: 'MediaProcessing' }"
              class="navbar-item"
            >
              <b-icon icon="link-variant" custom-size="default"></b-icon>
              <span>Workflow Chains</span>
            </router-link>
            <router-link
              v-if="isAdmin || isSuperAdmin"
              :to="{ name: 'AuditLogs' }"
              class="navbar-item"
            >
              <b-icon icon="history" custom-size="default"></b-icon>
              <span>Audit Logs</span>
            </router-link>
            <router-link
              v-if="isAdmin || isSuperAdmin"
              :to="{ name: 'ReportIssue' }"
              class="navbar-item"
              style="background: rgba(255, 107, 107, 0.1);"
            >
              <b-icon
                icon="alert-circle-outline"
                custom-size="default"
              ></b-icon>
              <span>Report Issue</span>
            </router-link>
            <router-link
              v-if="isSuperAdmin"
              :to="{ name: 'ManageOrganisations' }"
              class="navbar-item"
            >
              <b-icon icon="office-building" custom-size="default"></b-icon>
              <span>Organisations</span>
            </router-link>
          </div>
        </NavBarMenu>
        <NavBarMenu v-if="isAuthenticated" class="has-divider">
          <div class="is-user-name">
            <span>{{ getFirstName }}</span>
          </div>

          <div slot="dropdown" class="navbar-dropdown">
            <router-link :to="{ name: 'ManageMedia' }" class="navbar-item">
              <b-icon icon="settings" custom-size="default"></b-icon>
              <span>Manage Media</span>
            </router-link>

            <!-- <router-link
              v-if="isBuyer && showRecommendations"
              :to="{ name: 'Recommendations' }"
              class="navbar-item"
            >
              <b-icon icon="settings" custom-size="default"></b-icon>
              <span>Recommendations</span>
            </router-link> -->
            <router-link :to="{ name: 'EditProfile' }" class="navbar-item">
              <b-icon icon="account" custom-size="default"></b-icon>
              <span>Edit Profile</span>
            </router-link>
            <router-link :to="{ name: 'ChangePassword' }" class="navbar-item">
              <b-icon
                icon="shield-account-outline"
                custom-size="default"
              ></b-icon>
              <span>Change Password</span>
            </router-link>
            <!-- <router-link :to="{ name: 'Contact' }" class="navbar-item">
              <b-icon icon="at" custom-size="default"></b-icon>
              <span>Contact Us</span>
            </router-link> -->
            <hr class="navbar-divider" />
            <a class="navbar-item" @click="doLogout">
              <b-icon icon="logout" custom-size="default"></b-icon>
              <span>Log Out</span>
            </a>
          </div>
        </NavBarMenu>
      </div>
    </div>
  </nav>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapState, mapGetters, mapActions } from 'vuex'
import NavBarMenu from '@/components/NavBarMenu'
import config from '@/config'
import MediaApi from '@/api/media'

export default {
  name: 'NavBar',
  components: {
    NavBarMenu
  },
  data() {
    return {
      isMenuNavBarActive: false,
      query: '',
      searchResults: [],
      isSearching: false,
      searchFocussed: false,
      showRecommendations: false
    }
  },
  watch: {
    $route() {
      this.isMenuNavBarActive = false
      if (this.$route.name === 'Search' && this.$route.query.q) {
        this.query = this.$route.query.q
      } else {
        this.query = ''
      }
    }
  },
  created() {
    // Menu and recommendations features removed - buyers platform cleanup
    this.showRecommendations = false
  },
  computed: {
    getFirstName() {
      if (this.user) {
        return this.user.first_name
      }
      return ''
    },
    menuNavBarToggleIcon() {
      return this.isMenuNavBarActive ? 'close' : 'dots-vertical'
    },
    menuToggleMobileIcon() {
      return this.isAsideMobileExpanded ? 'backburger' : 'forwardburger'
    },
    config() {
      return config
    },
    displayAppName() {
      // Show organisation name if user is authenticated and has an organisation
      if (this.isAuthenticated && this.user && this.user.organisation && this.user.organisation.name) {
        return this.user.organisation.name
      }
      // Fall back to config app name
      return config.appName
    },
    ...mapState(['isNavBarVisible', 'isAsideMobileExpanded']),
    ...mapGetters(['user', 'isAuthenticated']),
    isTraffic() {
      return this.user && this.user.role && this.user.role.includes('traffic')
    },
    isScheduler() {
      return this.user && this.user.role && this.user.role.includes('scheduler')
    },
    isAdmin() {
      return this.user && this.user.role && this.user.role.includes('admin')
    },
    isSuperAdmin() {
      return (
        this.user && this.user.role && this.user.role.includes('superadmin')
      )
    }
  },
  methods: {
    ...mapActions(['logout']),
    search() {
      this.$router.push({ name: 'Search', query: { q: this.query } })
    },
    menuToggleMobile() {
      this.$store.commit('asideMobileStateToggle')
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = !this.isMenuNavBarActive
    },
    doLogout() {
      this.isMenuNavBarActive = false
      this.logout()
      this.$router.push({ name: 'Login' })
    },
    getSearch: debounce(function(query) {
      if (!query.length) {
        this.searchResults = []
        return
      }
      this.isSearching = true
      MediaApi.search(query).then(response => {
        this.searchResults = response
        this.isSearching = false
      })
    }, 500)
  }
}
</script>
